// const pathvar = {dypath: "http://localhost:1111/"}
// const pathvar = {dypath: "http://pluserp.co:1111"}
const pathvar = {dypath: process.env.REACT_APP_PLUSHELP_API_URL}

export default pathvar;